import axios from 'axios';

const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
const BASE_URL = process.env.REACT_APP_REPORTS_BASE_URL;

const uuid4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

/** Pull report id from game-server responses (shape varies by endpoint). */
export function extractReportIdFromResponse(payload) {
  if (payload == null || typeof payload !== 'object') return null;
  const candidates = [
    payload.id,
    payload.reportId,
    payload.report_id,
    payload.reportid,
    payload.data?.id,
    payload.data?.reportId,
    payload.data?.report_id,
    payload.data?.reportid,
    payload.data?.data?.id,
    payload.data?.data?.reportId,
    payload.data?.data?.report_id,
    payload.result?.id,
    payload.result?.reportId,
    payload.result?.report_id,
    payload.result?.data?.id,
    payload.result?.data?.reportId,
    payload.result?.data?.report_id,
    payload.report?.id,
    payload.report?.reportId,
    payload.report?.report_id,
  ];
  for (const c of candidates) {
    if (c != null && String(c).trim() !== '') return String(c).trim();
  }
  return null;
}


export async function refreshToken(currentToken) {
  const url = `${BASE_URL}/auth/rf-token`;
  const headers = {
    'client-secret': CLIENT_SECRET,
    'Content-Type': 'application/json',
    ...(currentToken && { Authorization: `Bearer ${currentToken}` }),
    'Idempotency-Key': uuid4(),
  };
  const response = await axios.get(url, { headers });
  return response.data.token;
}

function resolveGuestReportId(data) {
  const rid = data.reportId != null ? String(data.reportId).trim() : '';
  if (!rid) return null;
  const uid = data.userId != null ? String(data.userId).trim() : '';
  const gid = data.gameId != null ? String(data.gameId).trim() : '';
  if (uid && rid === uid) return null;
  if (gid && rid === gid) return null;
  return rid;
}

function guestScoreUpdateNotFound(err) {
  const body = err?.response?.data;
  if (err?.response?.status === 404) return true;
  if (body?.err?.code === 'P2025') return true;
  if (/no record was found/i.test(String(body?.err?.meta?.cause || ''))) return true;
  return false;
}

export async function sendReport(data) {
  const { sessionId, role, token } = data;
  if (role === 'demobypass') return true;

  const isGuest = role === 'GUEST_USER';
  if (isGuest) {
    const headers = {
      'client-secret': CLIENT_SECRET,
      'Content-Type': 'application/json',
      'Idempotency-Key': uuid4(),
    };
    const addPayload = {
      points: data.points,
      time: data.time,
      gameId: data.gameId,
      name: data.name,
      sessionId: data.sessionId,
      userId: data.userId,
      organizationId: data.organizationId,
      ans: '',
    };
    const effectiveReportId = resolveGuestReportId(data);

    if (!effectiveReportId) {
      const response = await axios({
        method: 'post',
        url: `${BASE_URL}/game/add/guest/score`,
        headers,
        data: addPayload,
      });
      return response.data;
    }

    const updatePayload = {
      points: data.points,
      time: data.time,
      reportId: effectiveReportId,
    };
    try {
      const response = await axios({
        method: 'post',
        url: `${BASE_URL}/game/update/guest/score`,
        headers,
        data: updatePayload,
      });
      return response.data;
    } catch (err) {
      if (guestScoreUpdateNotFound(err)) {
        const response = await axios({
          method: 'post',
          url: `${BASE_URL}/game/add/guest/score`,
          headers,
          data: addPayload,
        });
        return response.data;
      }
      throw err;
    }
  }

  // Registered user logic
  const isUpdate = Boolean(data.reportId);
  const url = isUpdate
    ? `${BASE_URL}/game-server/report/${data.reportId}`
    : `${BASE_URL}/game-server/report/add`;
  const method = isUpdate ? 'put' : 'post';

  let headers = {
    'client-secret': CLIENT_SECRET,
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
    'Idempotency-Key': uuid4(),
  };

  try {
    const response = await axios({ method, url, headers, data });
    return response.data;
  } catch (err) {
    if (err.response?.status === 401) {
      const newToken = await refreshToken(token);
      headers.Authorization = `Bearer ${newToken}`;
      const retry = await axios({ method, url, headers, data });
      return retry.data;
    }
    throw err;
  }
}